import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

// A caption track of a video, as listed by the YouTube Data API
export interface YouTubeCaption {
  snippet: {
    language: string;
    name: string;
    // 'standard' for uploaded captions, 'asr' for auto-generated ones, and 'forced'
    // for captions shown only when the video speaks another language
    trackKind: string;
    // 'serving' once the track can be shown
    status: string;
    isDraft: boolean;
  };
}

@Injectable({
  providedIn: 'root',
})
export class YouTubeDataApiService {
  static readonly API_KEY = 'AIzaSyDsKn1Xo09KnO_vVatbPlqJ7cwZgI5wsyk';
  static readonly CAPTIONS_URL =
    'https://youtube.googleapis.com/youtube/v3/captions';

  private httpClient = inject(HttpClient);

  // Lists the caption tracks of a public video, including auto-generated ones.
  // Each request costs 50 units of the API quota.
  async listCaptions(videoId: string): Promise<YouTubeCaption[]> {
    const params = new HttpParams()
      .set('part', 'snippet')
      .set('videoId', videoId)
      .set('key', YouTubeDataApiService.API_KEY);

    const response = await firstValueFrom(
      this.httpClient.get<{ items?: YouTubeCaption[] }>(
        YouTubeDataApiService.CAPTIONS_URL,
        { params },
      ),
    );

    return response?.items || [];
  }
}
